// extracted by mini-css-extract-plugin
export var aircallIframe = "_kw-3";
export var fabContainer = "_kw-5";
export var fabRinging = "_kw-6";
export var loadingOverlay = "_kw-4";
export var pulse = "_kw-7";
export var widgetContent = "_kw-2";
export var widgetPanel = "_kw-0";
export var widgetPanelExpanded = "_kw-1";